import {
  liveCallTasksApi,
  useGetLiveCallTasksQuery,
} from "app/store/liveCallTasks/api/liveCallTasksApi";
import { countLiveCallTodoTasks } from "app/store/liveCallTasks/slice/liveCallTasksSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

const useLiveCallTasks = () => {
  const [tasksByStatus, setTaskByStatus] = useState();
  const [liveCallTaskCount, setLiveCallTaskCount] = useState();

  const [selectedAccount, setSelectedAccount] = useState("all");
  const [patientNameSearch, setPatientNameSearch] = useState("");
  const [selectedAdvisory, setSelectedAdvisory] = useState("all");
  const [selectedMonthlyBatteryCheck, setSelectedMonthlyBatteryCheck] =
    useState("all");
  const [selectedDisconnectedDateOrder, setSelectedDisconnectedDateOrder] =
    useState("desc");

  const { data, isLoading, isFetching } = useGetLiveCallTasksQuery(
    {
      search: patientNameSearch,
      account: selectedAccount,
      advisory: selectedAdvisory,
      monthlyBatteryCheck: selectedMonthlyBatteryCheck,
      sort: selectedDisconnectedDateOrder,
    },
    { refetchOnMountOrArgChange: true }
  );

  const dispatch = useDispatch();

  useEffect(() => {
    handleLiveCallTasksData(data);
  }, [data]);

  const handleLiveCallTasksData = (data) => {
    const tasksByStatus =
      data?.reduce((acc, item) => {
        acc[item.status] = acc[item.status] || [];
        acc[item.status].push(...item.tasks);
        return acc;
      }, {}) || {};

    setTaskByStatus(tasksByStatus);
    countTasksByStatus(tasksByStatus);
  };

  const countTasksByStatus = (tasks) => {
    const taskCount = Object.entries(tasks).reduce(
      (acc, [status, accounts]) => {
        acc[status] = accounts.reduce(
          (sum, account) => sum + (account.patients?.length || 0),
          0
        );
        return acc;
      },
      {}
    );
    setLiveCallTaskCount(taskCount);
  };

  const handleCallLogSubmit = () => {
    dispatch(liveCallTasksApi.util.invalidateTags(["liveCallTasks"]));
    dispatch(countLiveCallTodoTasks(true));
  };

  const handleAccountFilter = (event) => {
    setSelectedAccount(event.target.value);
  };

  const handleSearchPatient = (event) => {
    setPatientNameSearch(event?.target?.value || "");
  };

  const handleAdvisoryFilter = (event) => {
    setSelectedAdvisory(event.target.value);
  };

  const handleMonthlyBatteryCheckFilter = (event) => {
    setSelectedMonthlyBatteryCheck(event.target.value);
  };

  const handleDisconnectedDateOrder = (event) => {
    setSelectedDisconnectedDateOrder(event.target.value);
  };

  return {
    isLoading,
    isFetching,
    tasksByStatus,
    selectedAccount,
    liveCallTaskCount,
    patientNameSearch,
    selectedAdvisory,
    selectedMonthlyBatteryCheck,
    selectedDisconnectedDateOrder,

    handleSearchPatient,
    handleAccountFilter,
    handleCallLogSubmit,
    handleAdvisoryFilter,
    handleMonthlyBatteryCheckFilter,
    handleDisconnectedDateOrder,
  };
};
export default useLiveCallTasks;
